import { Component, ChangeDetectionStrategy } from '@angular/core';
import {RouterModule} from "@angular/router";
import {NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'app-footer',
  imports: [
    RouterModule,
    NgOptimizedImage,
    NgOptimizedImage
  ],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
